import React from 'react';

import { IncentivesZDSBody } from '@components/IncentivesApp/components/IncentivesZDSBody';
import { ZDSPage } from '@components/shared/ZDSPage';

export const IncentivesZDSPage = () => <ZDSPage type='incentives' body={IncentivesZDSBody} />;
